<script setup lang="ts">
import { Participant } from '@collector/sportsapi-client-legacy'
import { isAwayTeam, isHomeTeam } from '@mobile/reusables/entityUtils'

import IncidentButton from '../../../Shared/IncidentButton/IncidentButton.vue'

interface Props {
  incidentId: number
  participant: Participant
  selected?: boolean
}

withDefaults(defineProps<Props>(), {
  selected: false,
})
</script>

<template>
  <IncidentButton
    :key="`swap-incident-${participant.counter}-button-${incidentId}`"
    class="w-full border-1"
    :class="{
      'border-home': isHomeTeam(participant),
      'border-away': isAwayTeam(participant),
      'bg-home/20': isHomeTeam(participant) && !selected,
      'bg-away/20': isAwayTeam(participant) && !selected,
    }"
    size="md"
    type="horizontal"
    :color="isHomeTeam(participant) ? 'home' : 'away'"
    :disabled="false"
    :incidentId
    :sendIncident="false"
  >
    <template #default="{ incidentName }">
      <span :class="selected ? 'text-white' : 'text-black'">
        {{ incidentName }}
      </span>
    </template>
  </IncidentButton>
</template>
